export const splitItems = (items, values) => {
    const checked = [];
    const unchecked = [];
    items.forEach((option) => values.includes(option.value)
        ? checked.push(Object.assign(Object.assign({}, option), { type: 'checked' }))
        : unchecked.push(Object.assign(Object.assign({}, option), { type: 'unchecked' })));
    return [checked, unchecked];
};
export const addCustomValues = (options, values) => {
    const optionValues = options.map((option) => option.value);
    const customValues = values.filter((value) => !optionValues.includes(value));
    const customOptions = customValues.map((customValue) => ({
        label: customValue,
        value: customValue,
    }));
    return [...options, ...customOptions];
};
//# sourceMappingURL=MenuContent.utils.js.map